<template>
    <div class="seeker-block">
        <div
            class="seeker-block__wrapper"
            v-for="(item, index) in count"
            :key="item"
        >
            <component
                :is="component"
                class="seeker-block__content"
                :index="index"
                ref="component"
                @change="onBlockDataChange"
            />
            <div class="seeker-block__remove" v-if="index !== 0">
                <button
                    @click="removeBlock(item, index)"
                    class="seeker-block__remove-btn"
                >
                    <z-icon
                        name="close"
                        width="24"
                        height="24"
                    />
                </button>
            </div>
        </div>
        <div class="seekers-form__add-button">
            <z-button kind="text" @click="addBlock('experience')">
                <span v-html="btnText"></span>
                <template v-slot:right>
                    <z-icon
                        name="plus"
                        width="24"
                        height="24"
                    />
                </template>
            </z-button>
        </div>
    </div>
</template>

<script>
import Experience from './Experience.vue'
import Education from './Education.vue'

export default {
    name: 'seeker-block',
    props: {
        component: {
            type: String,
            validator: prop => ['experience', 'education'].includes(prop),
            required: true
        },
        btnText: {
            String,
            default: 'Добавить'
        }
    },
    components: {
        Experience,
        Education
    },
    data () {
        return {
            error: '',
            count: [0],
            value: []
        }
    },
    methods: {
        addBlock (key) {
            this.count.push(this.count[this.count.length - 1] + 1)
        },
        removeBlock (item, index) {
            const countIndex = this.count.indexOf(item)
            this.count.splice(countIndex, 1)
            this.value.splice(index, 1)
        },
        onBlockDataChange (data) {
            this.value[data.index] = data.value
            this.$emit('change', {
                name: this.component,
                value: this.value
            })
        },
        validate () {
            let isValid = true

            this.$refs.component.forEach(item => {
                if (!item.validate()) isValid = false
            })

            if (!isValid) {
                this.error = 'Не все поля заполнены'
            } else {
                this.error = ''
            }

            return isValid
        },
        reset () {
            this.$refs.component.forEach(item => {
                item.reset()
            })
        }
    }
}
</script>

<style lang="scss">
.seeker-block {
    &__wrapper {
        display: flex;
        position: relative;

        & + & {
            margin-top: $token-spacers-m;
        }
    }

    &__content {
        flex-grow: 1;
    }

    &__remove-btn {
        background: none;
        padding: 0;
        border: none;
    }

    &__remove {
        position: relative;
        margin-left: $token-spacers-3-xs;
        padding-top: $token-spacers-2-xs;
        position: absolute;
        left: 100%;
        top: 0;
        height: 100%;

        @include breakpoint (mobile) {
            position: relative;
            left: 0;
            height: auto;
        }

        &:before {
            content: '';
            position: absolute;
            pointer-events: none;
            z-index: -1;
            width: 0;
            height: 100%;
            border-left: 1px dashed $token-colors-primary;
            top: 0;
            left: 50%;
        }
    }
}
</style>
